import React from "react";
import PropTypes from "prop-types";
import { TextField, FormControl } from "@mui/material";
import { Field, useFormikContext } from "formik";

const InputField = (props) => {
  const { handleBlur, setFieldValue } = useFormikContext();
  const {
    name,
    label,
    helperText,
    placeholder,
    size = "medium",
    fullWidth = true,
    variant = "outlined",
    required = false,
    readOnly = false,
    customOnBlur,
    fieldInputProps,
    handleChange = (event) => {
      setFieldValue(event.target.name, event.target.value);
    },
  } = props;

  return (
    <Field name={name}>
      {({ field }) => (
        <FormControl fullWidth={fullWidth}>
          <TextField
            {...props}
            {...field}
            autoComplete="off"
            name={name}
            fullWidth={fullWidth}
            size={size}
            variant={variant}
            required={required}
            placeholder={placeholder}
            helperText={helperText}
            label={label}
            InputProps={{
              readOnly,
              sx: {
                "& fieldset": { border: "none" },
              },
            }}
            inputProps={{
              ...fieldInputProps,
              sx: {
                bgcolor: "text.light",
                borderRadius: "6px",
              },
            }}
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#989898",
              },
            }}
            onChange={handleChange}
            onBlur={(event) => {
              if (customOnBlur) {
                customOnBlur();
              }
              handleBlur(event);
            }}
          />
        </FormControl>
      )}
    </Field>
  );
};

InputField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  size: PropTypes.any,
  variant: PropTypes.any,
  helperText: PropTypes.any,
  placeholder: PropTypes.string,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  handleChange: PropTypes.func,
};

export default InputField;
